'use client'

import { useState } from 'react'
import { useTranslations } from 'next-intl'
import { useRouter } from '@onclicks/sharedmobilei18n/routing'
import { useUser } from '@/kmsApp/providers/user-provider'
import { NavLink } from '../HeaderClient'

export const CompanySubmenu = ({
  link,
  setIsOpen,
}: {
  link: NavLink
  setIsOpen: (isOpen: boolean) => void
}) => {
  const t = useTranslations('menu_page')
  const { me, selectEntreprise } = useUser()
  const router = useRouter()
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false)

  const entreprises = me?.entreprisesDisponibles ?? []

  // `null` = à titre privé : les courses réservées ensuite ne relèvent d'aucune
  // entreprise (ni facture, ni tarif négocié, ni champ personnalisé).
  const handleSelect = async (idEntreprise: number | null) => {
    await selectEntreprise(idEntreprise)
    setIsSubmenuOpen(false)
    setIsOpen(false)
    router.refresh()
  }

  return (
    <div>
      <div
        className="px-6 py-2 hover:bg-white/10 transition-colors cursor-pointer text-lg font-normal flex items-center justify-between gap-2"
        onClick={() => setIsSubmenuOpen(!isSubmenuOpen)}
      >
        <p>{link.label}</p>
        <span className={`transition-transform text-sm ${isSubmenuOpen ? 'rotate-180' : ''}`}>
          ▾
        </span>
      </div>

      {isSubmenuOpen && (
        <div className="bg-white/5">
          {entreprises.map((entreprise) => (
            <div
              key={entreprise.id}
              onClick={() => handleSelect(entreprise.id)}
              className={`px-10 py-2 hover:bg-white/10 transition-colors cursor-pointer text-base ${
                me?.entrepriseActive?.idEntreprise === entreprise.id ? 'font-bold' : 'font-normal'
              }`}
            >
              {entreprise.nom}
            </div>
          ))}

          <div aria-hidden="true" className="mx-10 border-t border-white/15" />

          <div
            onClick={() => handleSelect(null)}
            className={`px-10 py-2 hover:bg-white/10 transition-colors cursor-pointer text-base ${
              me?.entrepriseActive ? 'font-normal' : 'font-bold'
            }`}
          >
            {t('private_mode')}
          </div>
        </div>
      )}
    </div>
  )
}
